module.exports = __webpack_public_path__ + "img/1457297959.8dbac236.jpg";